<div
  style="
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
    align-content: flex-start;
    gap: 10px;
    background: #f7fbff;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 10px;
  "
>
  <div style="order: 1; flex: 80">
    <div
      style="
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: columns;
        flex-wrap: nowrap;
        flex: 1;
        gap: 5px;
      "
    >
      <div style="order: 1; justify-content: center">
        <a href="/dashboard">
          <img src="/Circana-Logo.svg" height="50px" alt="Circana"
        /></a>
      </div>
    </div>
  </div>

  <div style="order: 2; flex: 20">
    <div
      style="
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        padding: 15px;
        gap: 5px;
      "
    >
      <div style="order: 1">
        <a href="https://www.circana.com" target="_blank">Corporate Website</a>
      </div>
      <div style="order: 2"><a routerLink="contact">Contact</a></div>
      <div style="order: 3"><a routerLink="help">Help</a></div>
    </div>
  </div>
</div>
